exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".title___2LXfr {\n  text-align: center;\n  margin: 1.2rem;\n  font-size: 20px;\n  font-weight: bold;\n  font-family: cursive;\n}\n\n.content___1eAmA {\n  padding: 0 0.64rem;\n  font-size: 14px;\n  text-indent: 2em;\n  line-height: 1.2rem;\n  font-family: STKaitiSC-Regular;\n}\n\n.share_photo___2UVFN {\n  width: 50%;\n  margin: auto;\n  margin-top: 2.666667rem;\n}\n.share_photo___2UVFN img {\n  width: 100%;\n}\np {\n  font-size: 0.64rem;\n  color: #666;\n  text-align: center;\n  margin-top: 1.066667rem;\n}\n", ""]);

// exports
exports.locals = {
	"title": "title___2LXfr",
	"content": "content___1eAmA",
	"share_photo": "share_photo___2UVFN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/test_detail_style.css
// module id = 799
// module chunks = 2